import { Icon } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { Box, Flex } from "@/components/layout/flexbox";
import { breakpoints } from "@/components/layout/Media";
import { FlexibleButton } from "@/components/pieces/button/FlexibleButton";
import { DifficultyTag } from "@/components/pieces/roleplays/DifficultyTag";
import { AvatarWithPrettyNull } from "@/components/pieces/users/AvatarWithPrettyNull";
import { SharingStatusIcon } from "@/components/ui/sharing/SharingStatusIcon";
import { MIDTEXT_COLOR } from "@/css/constants";
import { ListScenario, ProgramScenario } from "@/types/roleplays";

interface ProgramScenarioCardProps {
  scenario: ProgramScenario | ListScenario;
  onChoose: (selected: boolean) => void;
  isChosen: boolean;
}

export function ProgramScenarioCard({
  scenario,
  onChoose,
  isChosen,
}: ProgramScenarioCardProps) {
  return (
    <ScenarioCardContainer className="bas round-corners">
      <Flex alignItems="center" flexDirection={["column", "row"]}>
        <Box minWidth={100}>
          <AvatarWithPrettyNull
            user={{
              name: scenario.personaName,
              photo: scenario.personaPhotoUrl,
            }}
            size={100}
          />
        </Box>
        <Box mx={[0, 3]} textAlign={["center", "left"]} mt={[3, 0]}>
          <Box fontWeight={500} fontSize={18}>
            {scenario.name}
          </Box>
          {scenario.shortDesc ? (
            <Box mt={1} color={MIDTEXT_COLOR}>
              {scenario.shortDesc}
            </Box>
          ) : null}
          <Flex
            alignItems="center"
            mt={3}
            justifyContent={["center", "flex-start"]}
          >
            <Box>
              <DifficultyTag difficulty={scenario.difficulty} />
            </Box>
            <Box
              css={{
                marginLeft: 16,
                marginRight: 16,
                width: 1,
                height: 20,
                backgroundColor: "#E2E2E2",
              }}
            />
            {scenario.sharingStatus && (
              <Box>
                <SharingStatusIcon sharingStatus={scenario.sharingStatus} />
              </Box>
            )}
          </Flex>
        </Box>
      </Flex>
      <Box minWidth={115} width={["100%", 115]} mt={[24, 0]}>
        {!isChosen ? (
          <FlexibleButton
            fill={true}
            onClick={() => null}
            rightIcon={<Icon icon="plus" />}
            onClickCapture={() => onChoose(true)}
          >
            Include
          </FlexibleButton>
        ) : (
          <FlexibleButton
            fill={true}
            rightIcon={<Icon icon="tick" />}
            variant="primary"
            style={{ backgroundColor: "#27AE60" }}
            onClickCapture={() => onChoose(false)}
          >
            Included
          </FlexibleButton>
        )}
      </Box>
    </ScenarioCardContainer>
  );
}

const ScenarioCardContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  flex-direction: column;
  color: inherit;
  padding: 16px;

  @media (min-width: ${breakpoints.sm}px) {
    flex-direction: row;
  }
`;
